import type { DescriptorType } from '../../../../../../types/descriptor.types';

const TIMEFRAME_DIFF_PATTERN =
    /^TimeframeRelation\[period=(LTM|REPORT_PERIOD), referenceId=(?:DescriptorID\(value=(.+)\)|null)\]$/;

export function formatTimeframeDiffValue(
    value: string,
    descriptors: readonly Pick<DescriptorType, 'id' | 'label'>[],
): string {
    const match = TIMEFRAME_DIFF_PATTERN.exec(value);
    if (!match) {
        return value;
    }

    const [, period, referenceId] = match;
    const referenceLabel = referenceId === undefined
        ? 'none'
        : descriptors.find((descriptor) => descriptor.id === referenceId)?.label.trim() || referenceId;

    return `${period} (reference: ${referenceLabel})`;
}
